import type { Publication, SignatureTalk, SpeakingFormat } from '../lib/types';

export const siteLinks = {
  fivePhases: 'https://5phaseshealth.com/',
  newsletter: 'https://5phaseshealth.beehiiv.com/',
  newsletterSubscribe: 'https://5phaseshealth.beehiiv.com/subscribe',
  instagram: 'https://www.instagram.com/5phaseshealth/'
} as const;

export const contactDetails = {
  email: 'christina@5PhasesHealth.com'
} as const;

export const positioning = {
  name: 'Christina J Barea',
  roles: 'Qigong Instructor & Clinician · Certified Health Professional · Author · Speaker',
  promise: 'Holistic health based on Traditional Chinese Medicine',
  experience: 'Dedicated to human health and potential since 2003.'
} as const;

export const biography = [
  'Christina J Barea has been dedicated to human health and potential since 2003. She is a Senior Qigong Instructor, a master’s-level Medical Qigong Therapist, Certified Personal Trainer, Nutritionist, and Health Wellness Coach bridging Eastern energy medicine with Western exercise science.',
  'Her award-winning book Qigong Illustrated has helped thousands discover the healing power of movement and breath. Her forthcoming book, Foundations of Longevity, Vol. 1, blends Qigong and fitness into practical frameworks anyone can apply to modern life.',
  'A seasoned television host with her own Qigong show in Atlanta, Christina brings warmth, depth, and stage presence to every engagement. She has presented to audiences ranging from intimate gatherings to large conference groups.'
] as const;

export const signatureTalks: SignatureTalk[] = [
  {
    title: 'Beyond the Diagnosis',
    shortTitle: 'Reclaiming Autonomy in Chronic Illness Through Targeted Qigong and Physical Conditioning',
    description: 'A multi-layered framework integrating Traditional Chinese Medicine’s Five Element Theory with targeted physical conditioning and Qigong, moving patients from passive diagnosis toward active self-cultivation. Ideal for healthcare audiences.'
  },
  {
    title: 'It Is Not Too Late',
    shortTitle: 'Longevity Science and Movement After 40',
    description: 'Longevity research points to a striking conclusion: a large, modifiable share of how long and how well we live rests within daily behavior, and the benefit of change remains available even when it begins later in life. Movement is life.'
  },
  {
    title: 'The Art of Perseverance',
    shortTitle: 'Body, Breath, and Mind Through Natural Cycles',
    description: 'Drawing on the Three Treasures and Five Phases, audiences learn how Body, Breath, and Mind work together through natural cycles of effort and rest.'
  },
  {
    title: 'The Compound Effect of Small Habits',
    shortTitle: 'Small Practices, Sustainable Change',
    description: 'Lasting change comes from achievable results. One small habit ripples through Body, Breath, and Mind and compounds over time, accomplishing what willpower alone never could.'
  }
];

export const audienceOutcomes = [
  'Practical Qigong tools audiences can use immediately',
  'A clear framework for sustainable daily wellbeing',
  'Renewed energy, focus, and stress resilience',
  'Accessible techniques for all fitness levels',
  'Science-meets-tradition insights on longevity'
] as const;

export const speakingFormats: SpeakingFormat[] = [
  { title: 'Keynote', detail: '45–90 minutes · Large audiences' },
  { title: 'Workshop', detail: 'Half or full day · Interactive' },
  { title: 'Corporate program', detail: 'Ongoing wellness series' },
  { title: 'Virtual', detail: 'Webinar and hybrid formats' }
];

export const idealAudiences = [
  'Wellness conferences and summits',
  'Corporate wellness and HR events',
  'Healthcare and integrative medicine organizations',
  'Universities and educational institutions',
  'Community wellness organizations',
  'Retreat and leadership programs'
] as const;

export const publications: Publication[] = [
  {
    title: 'Qigong Illustrated',
    detail: 'Award-winning',
    status: 'published',
    coverImage: '/images/qigong-illustrated-cover.jpg',
    coverAlt: 'Qigong Illustrated book cover by Christina J. Barea',
    purchaseUrl: 'https://www.amazon.com/dp/B005DIB404'
  },
  {
    title: 'Foundations of Longevity, Vol. 1: Qigong & Fitness',
    detail: 'Forthcoming',
    status: 'forthcoming',
    coverImage: '/images/foundations-of-longevity-cover.png',
    coverAlt: 'Foundations of Longevity book cover by Christina J. Barea',
    purchaseUrl: null
  }
];

export const languages = ['English', 'Spanish', 'Italian'] as const;

export const testimonial = {
  quote: 'Christina has a rare gift—she makes ancient wisdom feel immediately accessible and deeply personal.'
} as const;
